module.exports = __webpack_public_path__ + "img/image85.4fff2671.png";